import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f797cbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bargain_rule" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bargain_rule_title" }, "Terms & Rules", -1))
const _hoisted_3 = ["innerHTML"]

import { ref, inject } from 'vue';
import headerMenu from '@/components/header/header.vue'
import { Toast } from 'vant'


export default /*#__PURE__*/_defineComponent({
  __name: 'BargainRule',
  setup(__props) {

const $http: any = inject("$http");
let rule_html = ref('')
const get_bargain_records_fn =  async() => {
 
  let formData = new FormData();
  formData.append('re_method','actBaseInfo')     
  formData.append('data', '')   
  await $http.get_nologin_post(formData).then((res:any) => {
    if (res.code === 200) {
      if(res.data.resultCode == 200){
        rule_html.value = res.data.data.actRule
      }else{
        Toast({
          message: res.data.resultMsg,
          duration: 3000
        })
      }
       
    } else {
      Toast({
        message: res.message,
        duration: 3000
      })
    }
  })
}
get_bargain_records_fn()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(headerMenu, {
      title: "Bargain",
      backgroundColor: "black",
      fontColor: "#ffffff"
    }),
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("div", {
        class: "bargain_rule_content",
        innerHTML: _unref(rule_html)
      }, null, 8, _hoisted_3)
    ])
  ]))
}
}

})